import { BASE_END_POINT } from "../../parametros";
import i18n from "i18next";

async function retornarLinkLogo(): Promise<string> {

    const url = `${BASE_END_POINT}/api-v1/comum-site/logo`;

    const response = await fetch(url, {
        headers: { 'Accept-Language': i18n.language }
    });

    if (!response.ok) {
        throw new Error(`Erro ao buscar logo. Código: ${response.status}`);
    }

    return await response.json() as string;
}

export {
    retornarLinkLogo
};
